import { gql } from '@apollo/client'

// Add new Boat
export const ADD_BOAT = gql`
    mutation AddBoat($boat: BoatInput!) {
        addBoat(boat: $boat) {
            code
            success
            message
        }
    }
`

// Update Boat
export const UPDATE_BOAT = gql`
    mutation UpdateBoat($boat: BoatInput!, $boatId: NonEmptyString!) {
        updateBoat(boat: $boat, boat_id: $boatId) {
            code
            success
            message
        }
    }
`

export const CHANGE_BOAT_ROUTE_CAPTAIN = gql`
    mutation ChangeBoatRouteCaptain(
        $historyId: NonEmptyString!
        $captainId: NonEmptyString!
        $activityDate: LocalDate!
    ) {
        changeBoatRouteCaptain(history_id: $historyId, captain_id: $captainId, activity_date: $activityDate) {
            code
            success
            message
        }
    }
`

export const CHANGE_BOAT_ROUTE = gql`
    mutation ChangeRouteBoat($historyId: NonEmptyString!, $boatId: NonEmptyString!, $activityDate: LocalDate!) {
        changeRouteBoat(history_id: $historyId, boat_id: $boatId, activity_date: $activityDate) {
            code
            success
            message
        }
    }
`

export const ADD_ROUTE_LUGGAGE_BOAT = gql`
    mutation addRouteLuggageBoat($history_id: NonEmptyString!, $luggage_boat_ids: [NonEmptyString!]!, $activity_date: LocalDate!) { 
        addRouteLuggageBoat(history_id: $history_id, luggage_boat_ids: $luggage_boat_ids, activity_date: $activity_date) {    
            code    
            success
            message
        }
    }
`;

export const ADD_BOAT_ROUTE_ADDITIONAL_CAPTAIN = gql`
    mutation AddBoatRouteAdditionalCaptain(
        $historyId: NonEmptyString!
        $captainId: NonEmptyString!
        $activityDate: LocalDate!
        $seamanOneId: NonEmptyString
        $seamanTwoId: NonEmptyString
    ) {
        addBoatRouteAdditionalCaptain(
            history_id: $historyId
            captain_id: $captainId
            activity_date: $activityDate
            seaman_one_id: $seamanOneId
            seaman_two_id: $seamanTwoId
        ) {
            code
            success
            message
        }
    }
`
